import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconSpacer: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconSpacer"><Path d="M2.5 19.5H21.5" stroke="currentColor" strokeLinecap="square"/><Path d="M2.5 12H5.5" stroke="currentColor" strokeLinecap="square"/><Path d="M10.5 12H13.5" stroke="currentColor" strokeLinecap="square"/><Path d="M18.5 12H21.5" stroke="currentColor" strokeLinecap="square"/><Path d="M2.5 4.5H21.5" stroke="currentColor" strokeLinecap="square"/></CentralIconBase>;
});

export default IconSpacer;
